
import { useCallback, useState } from 'react';
import { fetchStripeAccountId } from '@/services/transactions/stripeAccountService';

/**
 * Hook for refreshing the Stripe connection status
 */
export function useConnectionRefresh(
  checkConnection: (force?: boolean) => Promise<void>,
  clearCache: () => void,
  isConnected: boolean
) {
  const [refreshCount, setRefreshCount] = useState<number>(0);

  // Memoize the refreshConnection function to prevent unnecessary rerenders
  const refreshConnection = useCallback(async (options?: { force?: boolean }) => {
    // Prevent excessive refreshes by tracking a refresh count and only allowing
    // forced refreshes if explicitly requested
    if (options?.force) {
      setRefreshCount(prev => prev + 1);
      clearCache();
      // Single call to checkConnection - it will update the Context state
      // Removing the second call to prevent duplicate edge function invocations
      await checkConnection(true);
    } else if (!isConnected) {
      // Only do a non-forced refresh if we're not connected yet
      await checkConnection();
    } else {
      console.log('[Stripe Debug] Skipping refresh - already connected and force=false');
    }
  }, [clearCache, checkConnection, isConnected]);

  return {
    refreshConnection,
    refreshCount
  };
}
